<template>
  <v-card>
    <v-card-title class="pa-0">
      <v-tabs
        style="border-top-right-radius: 0.5rem; border-top-left-radius: 0.5rem"
        grow
        background-color="primary"
        active-class="subtitle-1 font-weight-bold"
        center-active
        v-model="activeTab"
      >
        <v-tab class="tabText" @click.prevent="setGetFavoritas(false)" :key="0">
          Câmeras
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === false && !loading && data.totalItems > 0) }">
            {{ flg_favorita === false && !loading && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>

        <v-tab class="tabText" @click.prevent="setGetFavoritas(true)" :key="1">
          Favoritas
          <span class="tab-count" :class="{ 'tab-count--hidden': !(flg_favorita === true && !loading && data.totalItems > 0) }">
            {{ flg_favorita === true && !loading && data.totalItems > 0 ? data.totalItems : '0' }}
          </span>
        </v-tab>
      </v-tabs>

      <v-container class="colab-toolbar-container" fluid v-if="cod_producao">
        <div class="colab-toolbar">
          <v-text-field
            prepend-inner-icon="mdi-magnify"
            solo flat dense hide-details
            placeholder=""
            background-color="surface_tertiary"
            v-model="filtro_texto"
            @input="onChange"
            aria-label="Buscar"
            class="colab-search"
          />

          <v-select
            v-if="activeTab === 0 && $store.state.cameras.selectedPraca"
            v-model="selectedPraca"
            :items="$store.state.pracas.pracas"
            placeholder="Praça"
            aria-label="Selecione a praça"
            solo flat dense hide-details
            background-color="surface_tertiary"
            item-value="cod_praca"
            item-text="sig_praca"
            return-object
            @change="handleChangePraca"
            class="colab-dropdown"
          />
        </div>

        <div v-if="data" class="columnWrapper">
          <template>
            <div
              v-for="item in data.items"
              :key="item.id"
              class="card-item-wrapper drag-source"
              :class="{ 'drag-source--dragging': draggingId === item.id }"
              draggable
              @dragstart="startDrag($event, item)"
              @dragend="endDrag"
            >
              <CardCamera
                :item="item"
                :getCameras="getCameras"
                :getCamerasModeradas="getCamerasModeradas"
                :isFavoritaTab="flg_favorita"
              />
            </div>
          </template>
        </div>
      </v-container>
    </v-card-title>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";
import { capitalizeString } from "@/utils/capitalizeString";
import CardCamera from "../Cards/Cameras/CardCamera.vue";
import { apiClient } from "@/services/api";
import { dragSourceMixin } from "@/mixins/dragAndDrop";

export default {
  mixins: [dragSourceMixin],
  components: { CardCamera },
  props: {
    data: { type: [Array, Object] },
    showModal: Function,
    closeModal: Function,
    currentCamerasPage: Number,
    cod_producao: Number,
    defaultPraca: Object,
  },
  data() {
    return {
      imagem_url: "",
      isModalFiltrosVisible: false,
      filtro_texto: "",
      flg_favorita: false,
      isModalImagemAprovadasVisible: false,
      midia_url_aprovadas: "",
      media_type: "",
      debounce: null,
      loading: false,
      activeTab: 0,
      selectedPraca: this.$store.state.cameras.selectedPraca || null,
      dragIdField: 'id',
    };
  },
  beforeMount() {
    this.selectedPraca = this.$store.state.cameras.selectedPraca || this.defaultPraca;
    this.filtro_texto = localStorage.getItem("@socialcam/filtro_texto_cameras") || "";
    this.flg_favorita =
      JSON.parse(localStorage.getItem("@socialcam/flg_favorita_cameras")) || false;
    this.activeTab = this.flg_favorita ? 1 : 0;
    this.setFlgFavorita(this.flg_favorita);
  },

  computed: {},
  methods: {
    ...mapActions({
      setSelectedPraca: "cameras/setSelectedPraca",
      getCameras: "cameras/getCameras",
      getCamerasModeradas: "cameras/getCamerasModeradas",
      setFiltroCameras: "cameras/setFiltroCameras",
      setFlgFavorita: "cameras/setFlgFavorita",
    }),
    async getPracas() {
      await apiClient.get("/listarPracas").then((response) => {
        this.pracas = response.data.pracas;
      });
    },

    async showModalImagem(midia_url_aprovadas, media_type) {
      this.isModalImagemAprovadasVisible = true;
      this.midia_url_aprovadas = midia_url_aprovadas;
      this.media_type = media_type;
    },

    async closeModalImagem() {
      this.isModalImagemAprovadasVisible = false;
    },

    capitalize(string) {
      return capitalizeString(string);
    },

    async handleChangePraca() {
      try {
        this.loading = true;
        await this.setSelectedPraca(this.selectedPraca);
        await this.getCameras({
          cod_praca: this.selectedPraca.cod_praca,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          filtro_texto: this.filtro_texto,
          flg_favorita: this.flg_favorita,
          page: this.$store.state.cameras.camerasProducao.currentPage || 1,
          size: 5,
        });
      } catch (error) {
        console.error(error);
        return this.$toast.error("Não foi possível filtrar por praça");
      } finally {
        this.loading = false;
      }
    },

    resetSelection() {
      this.selectedPraca = null;
      this.setSelectedCategoria(null);
      this.handleChangePraca(null);
    },

    async setGetFavoritas(flg_favorita) {
      this.flg_favorita = flg_favorita;
      this.setFlgFavorita(flg_favorita);
      localStorage.setItem("@socialcam/flg_favorita_cameras", flg_favorita);
      try {
        this.loading = true;
        await this.getCameras({
          cod_praca: this.selectedPraca.cod_praca,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          filtro_texto: this.filtro_texto,
          page: this.$store.state.cameras.camerasProducao.currentPage,
          size: 5,
          flg_favorita: this.flg_favorita,
        });
      } catch (error) {
        console.error(error);
        return this.$toast.error("Não foi possível buscar as favoritas");
      } finally {
        this.loading = false;
      }
    },

    onChange(e) {
      localStorage.setItem("@socialcam/filtro_texto_cameras", e);
      this.setFiltroCameras(e);
      clearTimeout(this.debounce);
      this.debounce = setTimeout(async () => {
        await this.getCameras({
          cod_praca: this.selectedPraca.cod_praca,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          filtro_texto: this.filtro_texto,
          page: this.$store.state.cameras.camerasProducao.currentPage,
          size: 5,
          flg_favorita: this.flg_favorita,
        });
      }, 1500);
    },
  },
  watch: {
    defaultPraca(newVal, oldVal) {
      // Only reset when production actually changes, not on tab restore
      if (oldVal && newVal && oldVal.cod_praca !== newVal.cod_praca) {
        this.selectedPraca = newVal;
        this.handleChangePraca();
      } else if (!oldVal && newVal && !this.selectedPraca) {
        this.selectedPraca = newVal;
        this.handleChangePraca();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-tab {
  text-transform: none !important;
  color: #171717 !important;
}

.v-text-field__details {
  display: none !important;
}

.card-item-wrapper {
  margin-bottom: 8px;
}
</style>
